<div mat-dialog-title="">{{edit? 'Edit Document' : 'Add Document'}}</div>
<mat-dialog-content style="overflow:unset;">
  <div class="row">
    <div class="column">
      <span> Add for</span>
      <div style="padding-left:30px;margin-top: 10px;">
        <tyl-radio-group #displayForRef arrange="vertical" [(selected)]="attachment.DocumentType" [values]="forOptions"
          [labels]="forOptions" [ids]="forOptions">
        </tyl-radio-group>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="column">
      <tyl-form-field style="width:100%;" label="Document Type">
        <mat-select #documentTypeRef name="documentType" id="documentType" [(ngModel)]="documentTypeIdAsString"
        (selectionChange)="documentTypeChanged()">
          <mat-option *ngFor="let item of documentTypes;" [value]="item.Id">
            <span>{{item.CodeDescription}}</span>
          </mat-option>
        </mat-select>
      </tyl-form-field>
    </div>
  </div>

  <div class="row">
    <div class="column">
      <tyl-form-field label="Description *" style="width: 100%;"
        hint="{{200 - (attachment.Description ? attachment.Description.length : 0)}} characters left"
        style="width: 100%">
        <textarea matInput #descriptionField [(ngModel)]="attachment.Description" [maxlength]="200"
          id="descriptionInput" name="Description" rows="5" style="resize: none;"></textarea>
      </tyl-form-field>
    </div>
  </div>
  <div class="row">
    <div class="column">
      <add-file *ngIf="!edit" [(fileString)]="attachment.MyFileBase64String" [(fileName)]="attachment.OriginalFileName"
        [(fileExtension)]="attachment.FileExtension" [(fileType)]="attachment.FileType"></add-file>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="save.png" label="Save" (clickEvent)="save()"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="close()"></tyl-button>
  </div>
</mat-dialog-actions>